module.exports = __webpack_public_path__ + "img/27.67086f9f.jpg";